// Who can join a project, for the pickers (20261016090000_create_project.sql).
//
// project_people is a definer RPC: the whole eligible roster at projects:full,
// or for a project's lead role on that project. Everyone else gets an error,
// and the pickers simply stay empty.
import { useEffect, useState } from 'react';
import { supabase } from './supabase';

export type EligiblePerson = {
  id: string;
  name: string;
  title: string | null;
  /** May be a Lead or Member; false means Viewer only. */
  can_edit: boolean;
};

/** null while loading; [] when the caller may not list people. */
export const useProjectPeople = (projectId: string | null): EligiblePerson[] | null => {
  const [people, setPeople] = useState<EligiblePerson[] | null>(null);
  useEffect(() => {
    if (!supabase) return;
    let live = true;
    void supabase
      .rpc('project_people', projectId ? { p_project: projectId } : {})
      .then(({ data, error }) => {
        if (live) setPeople(error ? [] : ((data as EligiblePerson[]) ?? []));
      });
    return () => {
      live = false;
    };
  }, [projectId]);
  return people;
};
